exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-table-add{display:flex}.my-table-add .col-1{padding:0!important;width:100%}@media (max-width:425px){.my-table-add .col-1{text-align:right}}.my-table-add .col-1 .my-btn{padding:3px 10px!important;margin:0 8px!important;text-transform:uppercase;height:100%}@media (max-width:425px){.my-table-add .col-1 .my-btn{margin:8px 0!important;height:26px}}", ""]);

// exports
